export default function Iframe({ url }) {
  let formatedUrl = validateYoutubeUrl(url)

  return (
    <div style={{ height: 0, paddingBottom: '56.25%', position: 'relative' }}>
      <iframe
        style={{
          border: 'none',
          borderRadius: 16,
          bottom: 0,
          height: '100%',
          left: 0,
          position: 'absolute',
          width: '100%',
        }}
        src={formatedUrl}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  )
}

// Possible url formats:
// www.youtube.com/watch?v=aME8oBF9u50
// https://www.youtube.com/watch?v=aME8oBF9u50
// https://youtu.be/aME8oBF9u50

// Padronized url format:
// https://www.youtube.com/embed/aME8oBF9u50

function validateYoutubeUrl(url) {
  let formatedUrl = url
  if (!url.startsWith('http')) {
    formatedUrl = `https://${url}`
  }
  if (url.includes('/watch?v=')) {
    formatedUrl = formatedUrl.replace('/watch?v=', '/embed/')
  }
  if (url.includes('youtu.be/')) {
    formatedUrl = formatedUrl.replace('youtu.be/', 'www.youtube.com/embed/')
  }
  return formatedUrl
}
